var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-mobile-autocomplete',{ref:"my-ctrl",attrs:{"value":_vm.internal_value,"items":_vm.items,"search":_vm.doSearch,"label":_vm.label,"placeholder":"Search organizations","disable_group_text":"","optional":"","dialog_only":_vm.dialog_only},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }